interface Column {
  key: string;
  label: string;
  highlight?: boolean;
}

interface SizeTableProps {
  title: string;
  columns: Column[];
  data: Record<string, string | number>[];
}

export default function SizeTable({ title, columns, data }: SizeTableProps) {
  return (
    <div className="overflow-x-auto rounded-lg border border-background-200/60">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-secondary-100">
            {columns.map((col) => (
              <th
                key={col.key}
                className={`px-4 py-3 text-left whitespace-nowrap font-semibold ${
                  col.highlight ? 'text-primary-700' : 'text-foreground-800'
                }`}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx} className={idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
              {columns.map((col) => (
                <td
                  key={col.key}
                  className={`px-4 py-3 whitespace-nowrap ${
                    col.highlight ? 'text-primary-700 font-medium' : 'text-foreground-700'
                  }`}
                >
                  {row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}